export default "__VITE_ASSET__DFWw3xbh__"